import type { CareerPathResponse } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (careerPaths: CareerPathResponse[]) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Career Paths',
    description:
      'Career paths available at this employer, grouped by category. Each career path chip is clickable for more detail.',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Career Paths by Category',
    display:
      'Grouped chip lists — career paths organized by career category, sorted by category size',
    data: {
      career_paths: careerPaths,
    },
  });
};
